export const AMAZON_TAG = "dessertisans-20"

const AMAZON_URL = /^https?:\/\/(amzn\.to|(www\.)?amazon\.[a-z.]+)\//i

// Legacy amazon.com.au links (old majckitchen-22 tag) whose ASINs do not exist
// on amazon.com. Mapped to the US products recommended elsewhere on the site.
const LEGACY_ASIN_REPLACEMENTS = {
  // Weight scale -> Taylor digital kitchen scale
  B076S2WNSK: `https://www.amazon.com/dp/B00CR29Q4U?tag=${AMAZON_TAG}`,
  // Infrared thermometer gun -> search (no US equivalent linked on the site)
  B07CNDBV19: `https://www.amazon.com/s?k=infrared+thermometer+cooking&tag=${AMAZON_TAG}`,
  // Immersion hand blender -> Dynamic MiniPro hand blender
  B001R4BEFI: "https://amzn.to/4rN2bs6",
}

// Products no longer available in the US, swapped site-wide for their
// replacements. Keys are the links as they appear in Contentful.
const LINK_REPLACEMENTS = {
  // bamix hand blender -> Dynamic MiniPro hand blender
  "https://amzn.to/2Xl2QUB": "https://amzn.to/4rN2bs6",
  // Robot Coupe MicroMix -> Dynamic MiniPro hand blender
  "https://amzn.to/3TZ5pIb": "https://amzn.to/4rN2bs6",
  // KitchenAid Pro 600 -> KitchenAid Classic 4.5 Qt stand mixer
  "https://amzn.to/2T9vucE": "https://amzn.to/3Tqh3jK",
  // Fine mesh strainer -> strainer category page
  "https://amzn.to/3A1ZK9Q": "https://amzn.to/3TNSkpC",
  // Silpat half-sheet mat -> Koolstuffs silicone baking mats
  "https://amzn.to/3pehf1b": "https://amzn.to/4AW9Dpb",
  // Breville Sous Chef -> Cuisinart 14-cup food processor
  "https://amzn.to/3iBg7Sz": "https://amzn.to/4znTCXs",
  // De Buyer Valrhona tart ring -> Keewah perforated tart ring
  "https://amzn.to/3cwLYmA": "https://amzn.to/47NsFk0",
  // Silpat Silpain perforated mat -> microperforated baking mats
  "https://amzn.to/36wRNfH": "https://amzn.to/4znTIyi",
  // Goldbaking chocolate bar mould -> GRAINRAIN polycarbonate bar mould
  "https://amzn.to/3lMXPE5": "https://amzn.to/4j6ZPlL",
  // Homy Feel round cutters -> Bukuwa round cutter set
  "https://amzn.to/3h4220U": "https://amzn.to/4ibrd0X",
}

export const isAmazonLink = (uri) => AMAZON_URL.test((uri || "").trim())

export const affiliateUri = (rawUri) => {
  if (!isAmazonLink(rawUri)) return rawUri
  const uri = rawUri.trim()

  if (LINK_REPLACEMENTS[uri]) return LINK_REPLACEMENTS[uri]

  const legacyAsin = Object.keys(LEGACY_ASIN_REPLACEMENTS).find((asin) =>
    uri.includes(asin)
  )
  if (legacyAsin) return LEGACY_ASIN_REPLACEMENTS[legacyAsin]

  if (/amazon\./i.test(uri) && !/[?&]tag=dessertisans-20\b/.test(uri)) {
    const url = new URL(uri)
    url.searchParams.set("tag", AMAZON_TAG)
    return url.toString()
  }

  return uri
}

// True when any value in the (possibly nested) content contains an Amazon link.
export const containsAmazonLinks = (content) =>
  /https?:\/\/(amzn\.to|(www\.)?amazon\.[a-z.]+)\//i.test(
    JSON.stringify(content || "")
  )
